import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icons/distance.svg")